import { Injectable } from '@angular/core';
import { take } from 'rxjs';

import { SbDialogService } from '../../../../../libs/ui/src';
import { PayrollDialogComponent } from '../payroll/payroll-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class PayrollOnboardingService {
  public constructor(private readonly dialogService: SbDialogService) {}

  public openDialog(originator = 'onboarding') {
    return this.dialogService
      .setSize('xxl')
      .open(PayrollDialogComponent, { data: { originator } })
      .closed.pipe(take(1));
  }
}
